export default __webpack_public_path__ + "static/media/weather-photo.893fc9f2.jpg";